import { render, staticRenderFns } from "./vuex-checkboxes-list.vue?vue&type=template&id=44af0dff&scoped=true"
import script from "./vuex-checkboxes-list.vue?vue&type=script&lang=js"
export * from "./vuex-checkboxes-list.vue?vue&type=script&lang=js"
import style0 from "./vuex-checkboxes-list.vue?vue&type=style&index=0&id=44af0dff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44af0dff",
  null
  
)

export default component.exports